import { useContext, useEffect, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import axios from 'axios';
import { getHeaders } from '../../request';
import Imagens from '../anexos/imagens';
import { SITUACAO_LAUDO } from './constantes';
import { temPermissaoRBAC, temPermissaoRede } from '../../secutity/rbac';
import Priorizar from './priorizar';
import Invalidar from './invalidar';
import { PERMISSOES, TABAGISMO } from '../../common/Constants';
import { useSignals } from '@preact/signals-react/runtime';
import { useSignal } from '@preact/signals-react';
import alerta from '../../signals/alerta';
import usuario from '../../signals/usuario';
import {
    SttTextItem,
    SttCircularProgress,
    SttNotification,
    SttAlertTitle,
    SttTranslateHook,
    SttCtrlP
} from '@stt-componentes/core';
import { SttContentDrawer } from '@stt-componentes/core-v2';
import { SttIMC } from '@stt-componentes/paciente'
import { NotificationManager } from 'react-notifications';
import { SECOES, REACT_KEYS } from './fieldNames';
import { graficosInvalidacao } from '../../common/graficosInvalidacoes';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({

    carregando: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },

    notificationContent: {
        display: 'flex',
        flexDirection: 'column',
        color: '#fff'
    },

    notification: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
        backgroundColor: '#fff',
        width: 'fit-content',
        maxWidth: '100%',
    },

    containerMotivo: {
        border: 'solid #dfdddd 3px',
        borderRadius: 10,
        overflow: 'hidden',
        display: 'inline-block',
        backgroundColor: '#fff'
    },

    invalidacaoHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(3),
        flexWrap: 'nowrap',
        backgroundColor: '#dfdddd',
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5
    },

    headerEsquerda: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
    },

    iconeInfo: {
        color: '#f5a623',
        fontSize: 48,
        marginTop: 2
    },

    responsavel: {
        display: 'block',
        fontSize: 15,
        marginBottom: theme.spacing(1),
        color: '#222'
    },

    motivo: {
        margin: 0,
        fontSize: 20,
        fontWeight: 600,
        color: '#000'
    },

    data: {
        fontSize: 15,
        color: '#000',
        whiteSpace: 'nowrap'
    },

    legendaContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        paddingLeft: 15
    },

    legendaItem: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        fontSize: 16,
        color: '#555',
        fontWeight: 500,
    },

    bolinhaLaranja: {
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: '#f5a623',
        flexShrink: 0,
    },

    bolinhaAzul: {
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: '#5fa8e8',
        flexShrink: 0,
    },

    graficosContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(5),
        padding: theme.spacing(2, 4, 4, 4),
    },

    grafico: {
        width: '48%',
        maxWidth: 350,
        height: 250,
        borderRadius: 8,
        objectFit: 'contain',
        backgroundColor: '#fff'
    },

    observacaoContainer: {
        padding: theme.spacing(2),
        fontSize: 15,
        color: '#444'
    }

}));

const DadosExame = (props) => {
    const { id, voltarFn, imprimirFn, imprimirProtocoloFn, imprimirTermoFn, ocultarBotoes = false } = props;

    const classes = useStyles();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const ESPIRO_API_BASE_URL = global.gConfig.url_base_espiro;
    const drawerRef = useRef();

    const exame = useSignal(null);
    const priorizar = useSignal(false);
    const invalidar = useSignal(false);
    const permissaoBtns = useSignal([]);
    const comorbidades = useSignal([]);

    useSignals();

    useEffect(() => {

        if (usuario.value.perfisRBAC && exame.value) {
            let rede;
            usuario.value.perfisRBAC.forEach(p => {
                p.redes && p.redes.forEach(r => {
                    if (r.id === exame.value.exame.id_rede_telemedicina) {
                        rede = r;
                    }
                });
            });
            if (rede) {
                permissaoBtns.value = [
                    temPermissaoRede(rede[0], PERMISSOES.INVALIDAR_EXAME),
                    temPermissaoRede(rede[0], PERMISSOES.PRIORIZAR_EXAME)
                ];
            }
        }

        axios
            .get(`${ESPIRO_API_BASE_URL}/exame/${id}`, { headers: getHeaders() })
            .then((response) => {
                const { data } = response;
                exame.value = data;
            })
            .catch(err => {
                const { response } = err;
                let msg = strings.mensagemErroGeral;
                let arrMensagem = [];
                if (response) {
                    const { data } = response;
                    data.errors.forEach(error => {
                        arrMensagem.push(`- ${error.message}`);
                    });
                    msg = arrMensagem.join('\n');
                }

                alerta.value = {
                    title: strings.erro,
                    message: msg,
                    type: 'error',
                    open: true,
                    options: [
                        {
                            title: strings.ok,
                            onClick: () => {
                                alerta.value = { ...alerta.value, open: false };
                                voltarFn();
                            }

                        }
                    ],
                    onClose: () => {
                        alerta.value = { ...alerta.value, open: false };
                        voltarFn();
                    }
                };
            });
    }, []);

    const callbackImpedirImpressao = () => {
		if (exame.value.exame.valido) {
			imprimirFn(id);
		} else {
            NotificationManager.error(strings.impressaoDesabilitada);
		}
	};

    const descricaoInvalidacao = exame.value?.exame?.descricao_invalidacao?.toUpperCase() || '';
    const chaveGrafico = Object.keys(graficosInvalidacao).find((chave) =>
        descricaoInvalidacao.includes(chave)
    );
    const graficos = chaveGrafico ? graficosInvalidacao[chaveGrafico] : null;

    console.log('Descrição:', descricaoInvalidacao);
    console.log('Graficos:', graficos);
    console.log('Exame completo:', exame.value);

    return (
        <>
            {!exame.value 
                ? (
                <div className={classes.carregando}>
                    <SttCircularProgress color="primary" />
                </div>
            ) : (
                <>
                    <SttContentDrawer
                        titulo={exame.value.exame.descricao_exame}
                        onClickVoltar={voltarFn}
                        ref={drawerRef}
                        secoesErro={[SECOES.DADOS_DO_PACIENTE, SECOES.DADOS_DO_EXAME, SECOES.OUTRAS_INFORMACOES, SECOES.LAUDO]}
                        botoes={[
                            {
                                key: REACT_KEYS.BTN_IMPRIMIR,
                                descricao: strings.imprimir,
                                type: 'button',
                                variant: 'contained',
                                color: 'primary',
                                show: exame.value.exame.valido,
                                onClick: () => imprimirFn(id),
                            },
                            {
                                key: REACT_KEYS.BTN_PROTOCOLO,
                                descricao: strings.protocolo,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show: exame.value.exame.valido,
                                onClick: () =>
                                    imprimirProtocoloFn({
                                        ...exame.value.exame,
                                        id: exame.value.exame.id_exame,
                                    }),
                            },
                            {
                                key: REACT_KEYS.BTN_PRIORIZAR,
                                descricao: strings.priorizar,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show:
                                    (permissaoBtns.value[1] ||
                                        (permissaoBtns.value[1] === undefined &&
                                            temPermissaoRBAC(usuario, PERMISSOES.PRIORIZAR_EXAME))) &&
                                    exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO &&
                                    exame.value.exame.valido,
                                onClick: () => (priorizar.value = true),
                            },
                            {
                                key: REACT_KEYS.BTN_INVALIDAR,
                                descricao: strings.invalidar,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show:
                                    (((permissaoBtns.value[0] ||
                                        (permissaoBtns.value[0] === undefined &&
                                            temPermissaoRBAC(usuario, PERMISSOES.INVALIDAR_EXAME))) &&
                                        exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO) ||
                                        (temPermissaoRBAC(
                                            usuario,
                                            PERMISSOES.INVALIDAR_EXAME_LAUDADO
                                        ) &&
                                            exame.value.exame.situacao_laudo === SITUACAO_LAUDO.COM_LAUDO)) &&
                                    exame.value.exame.valido,
                                onClick: () => (invalidar.value = true),
                            },
                            {
                                key: REACT_KEYS.BTN_TERMO,
                                descricao: strings.imprimirTermo,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show: exame.value.exame.valido,
                                onClick: () => imprimirTermoFn(exame.value.exame),
                            },
                        ]}
                        conteudo={[
                            {
                                key: REACT_KEYS.SEC_DADOS_DO_PACIENTE,
                                id: SECOES.DADOS_DO_PACIENTE,
                                titulo: strings.paciente,
                                show: true,
                                children: (
                                    <div>
                                        <SttTextItem key="1" title={strings.nome} content={exame.value.exame.nome_paciente} />
                                        <SttTextItem key="2" title={strings.dataNascimento} content={exame.value.exame.data_nascimento_paciente_formatada} />
                                        <SttTextItem key="3" title={strings.sexo} content={exame.value.exame.sexo_paciente} />
                                        {exame.value.indicacao && <SttTextItem key="4" title={strings.peso} content={`${exame.value.indicacao.peso_paciente} kg`} />}
                                        {exame.value.indicacao && <SttTextItem key="5" title={strings.altura} content={`${exame.value.indicacao.altura_paciente} cm`} />}
                                        <SttTextItem key="6" title={strings.idade} content={exame.value.exame.idade_paciente} />
                                        {exame.value.exame.cartao_sus_paciente && <SttTextItem key="7" title={strings.cns} content={exame.value.exame.cartao_sus_paciente} />}

                                        {
                                            exame.value.indicacao?.peso_paciente && exame.value.indicacao?.altura_paciente && exame.value.exame.data_nascimento &&
                                            <SttIMC values={{
                                                peso: exame.value.indicacao.peso_paciente,
                                                altura: exame.value.indicacao.altura_paciente,
                                                dataNascimento: exame.value.exame.data_nascimento,
                                            }} strings={strings} />
                                        }
                                    </div>
                                ),
                            },
                            {
                                key: REACT_KEYS.SEC_DADOS_DO_EXAME,
                                id: SECOES.DADOS_DO_EXAME,
                                titulo: strings.dadosExame,
                                show: true,
                                children: (
                                    <div>
                                        <SttTextItem key="1" title={strings.modalidade} content={exame.value.exame.descricao_modalidade} />
                                        <SttTextItem key="2" title={strings.dataExame} content={`${exame.value.exame.data_exame} ${global.gConfig.sufixo_data_hora}`} />
                                        <SttTextItem key="3" title={strings.protocolo} content={exame.value.exame.protocolo_rctm} />
                                        <SttTextItem key="4" title={strings.requisicao} content={exame.value.exame.requisicao} />
                                        <SttTextItem key="5" title={strings.instituicao} content={exame.value.exame.nome_instituicao} />
                                        <SttTextItem key="6" title={strings.medicoSolicitante} content={exame.value.exame.nome_medico_solicitante} />
                                        {exame.value.exame.nome_medico_executor && <SttTextItem key="7" title={strings.medicoExecutor} content={exame.value.exame.nome_medico_executor} />}
                                    </div>
                                )
                            },
                            {
                                key: REACT_KEYS.SEC_OUTRAS_INFORMACOES,
                                id: SECOES.OUTRAS_INFORMACOES,
                                titulo: strings.outrasInformacoes,
                                show: exame.value.indicacao || exame.value.exame.observacao_tecnica,
                                children: (
                                    <div>
                                        {exame.value.exame.observacao_tecnica && <SttTextItem key="1" title={strings.observacaoTecnica} content={exame.value.exame.observacao_tecnica} />}
                                        {exame.value.indicacao.descricacao_tabagismo && <SttTextItem key="2" title={strings.tabagismo} content={exame.value.indicacao.descricacao_tabagismo} />}
                                        {
                                            (exame.value.indicacao.tabagismo === TABAGISMO.FUMANTE || exame.value.indicacao.tabagismo === TABAGISMO.EX_FUMANTE) &&
                                            <>
                                                <SttTextItem key="2.1" title={strings.cigarrosDia} content={exame.value.indicacao.cigarros_dia} />
                                                <SttTextItem key="2.2" title={strings.anosFuma} content={exame.value.indicacao.anos_tabagismo} />
                                            </>
                                        }
                                        {exame.value.indicacao.tabagismo === TABAGISMO.EX_FUMANTE && <SttTextItem key="2.3" title={strings.anosParouFumo} content={exame.value.indicacao.anos_parou_fumar} />}

                                        <SttTextItem key="3" title={strings.etilismo} content={exame.value.indicacao.etilismo} />

                                        {comorbidades.value.length > 0 && <SttTextItem key="4" title={strings.comorbidades} content={comorbidades.value.join(', ')} />}
                                        {exame.value.indicacao.motivo_exame && <SttTextItem key="5" title={strings.motivoExame} content={exame.value.indicacao.motivo_exame} />}
                                        {exame.value.indicacao.resumo_historia_clinica && <SttTextItem key="6" title={strings.observacoes} content={exame.value.indicacao.resumo_historia_clinica} />}
                                        {exame.value.indicacao.hmf && <SttTextItem key="7" title={strings.hmf} content={exame.value.indicacao.hmf} />}
                                        {exame.value.indicacao.hmp && <SttTextItem key="8" title={strings.hmp} content={exame.value.indicacao.hmp} />}
                                        {exame.value.indicacao.medicamentos_em_uso && <SttTextItem key="9" title={strings.medicamentosUso} content={exame.value.indicacao.medicamentos_em_uso} />}
                                    </div>
                                ),
                            },
                            {
                                key: REACT_KEYS.SEC_INVALIDO,
                                id: SECOES.INVALIDO,
                                titulo: strings.exameInvalidado,
                                show: !exame.value.exame.valido, 
                                children: (
                                    <div className={classes.notification}>
                                        
                                        <div className={classes.containerMotivo}>

                                            <div className={classes.invalidacaoHeader}>

                                                <div className={classes.headerEsquerda}>
                                                    <ErrorOutlineIcon className={classes.iconeInfo} />

                                                    <div>
                                                        <span className={classes.responsavel}>
                                                            {`${strings.responsavel}: ${exame.value.exame.responsavel_invalidacao}`}
                                                        </span>

                                                        <h2 className={classes.motivo}>
                                                            {`${strings.motivo}: ${exame.value.exame.descricao_invalidacao}`}
                                                        </h2>
                                                    </div>

                                                </div>

                                                <span className={classes.data}>
                                                    {`${exame.value.exame.data_invalidacao} - ${global.gConfig.sufixo_data_hora} BR`}
                                                </span>
                                                
                                            </div>

                                            {graficos ? (
                                                <>
                                                    <div className={classes.legendaContainer}>
                                                        <div className={classes.legendaItem}>
                                                            <span className={classes.bolinhaLaranja}></span>

                                                            <span>
                                                                Hesitação; Início lento; Volume extrapolado grande
                                                            </span>
                                                        </div>

                                                        <div className={classes.legendaItem}>
                                                            <span className={classes.bolinhaAzul}></span>

                                                            <span>
                                                                Descarte a curva; Técnico: sopre MAIS RÁPIDO
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className={classes.graficosContainer}>
                                                        <img
                                                            src={graficos?.volumeTempo}
                                                            alt="Volume x Tempo"
                                                            className={classes.grafico}
                                                        />
                                                        <img
                                                            src={graficos?.fluxoVolume}
                                                            alt="Fluxo x Volume"
                                                            className={classes.grafico}
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                exame.value.exame.motivo_invalidacao && (
                                                    <div className={classes.observacaoContainer}>
                                                        <strong>Observação:</strong>{' '}
                                                        {exame.value.exame.motivo_invalidacao}
                                                    </div>
                                                )
                                            )}                                   
                                        </div>

                                    </div>
                                )
                            },
                            {
                                key: REACT_KEYS.SEC_LAUDO,
                                id: SECOES.LAUDO,
                                titulo: strings.laudo,
                                show: temPermissaoRBAC(usuario, [PERMISSOES.VISUALIZAR_LAUDO, PERMISSOES.LAUDAR_EXAME_FABRICA, PERMISSOES.LAUDAR_EXAME]) && exame.value.laudo, 
                                children: (
                                    <div dangerouslySetInnerHTML={{ __html: exame.value.laudo }}></div>
                                )
                            },
                            {
                                key: REACT_KEYS.IMAGENS,
                                id: SECOES.IMAGENS,
                                titulo: strings.imagens,
                                show: temPermissaoRBAC(usuario, [PERMISSOES.VISUALIZAR_IMAGEM, PERMISSOES.LAUDAR_EXAME_FABRICA, PERMISSOES.LAUDAR_EXAME]), 
                                children: (
                                    <Imagens idExame={exame.value.exame.id_exame} />
                                ) 
                            }

                        ]}
                    />
                    <SttCtrlP callback={callbackImpedirImpressao} />

                    {
                        (permissaoBtns[1] ||
                            (permissaoBtns[1] === undefined && temPermissaoRBAC(usuario, PERMISSOES.PRIORIZAR_EXAME))) &&
                        exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO && exame.value.exame.valido &&
                        <Priorizar
                            priorizar={priorizar.value}
                            setPriorizar={(p) => priorizar.value = p}
                            idExame={id.value}
                            idInstituicao={exame.value.exame.id_instituicao}
                            callback={voltarFn}
                        />
                    }

                    {
                        (((permissaoBtns[0] ||
                            (permissaoBtns[0] === undefined && temPermissaoRBAC(usuario, PERMISSOES.INVALIDAR_EXAME))) &&
                            exame.value.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO) ||
                            (temPermissaoRBAC(usuario, PERMISSOES.INVALIDAR_EXAME_LAUDADO) &&
                                exame.value.exame.situacao_laudo === SITUACAO_LAUDO.COM_LAUDO)) &&
                        exame.value.exame.valido &&
                        <Invalidar
                            invalidar={invalidar.value}
                            setInvalidar={(i) => invalidar.value = i}
                            idExame={id.value}
                            idInstituicao={exame.value.exame.id_instituicao}
                            idModalidade={exame.value.exame.id_modalidade}
                            callback={voltarFn}
                        />
                    }
                </>
            )}
        </>
    )
}

export default DadosExame;